import { useMemo } from 'react';

interface PremiumBackgroundProps {
  subtle?: boolean;
}

function Starfield({ count = 48 }: { count?: number }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: `${(i * 17.3 + 7) % 100}%`,
        top: `${(i * 23.7 + 11) % 100}%`,
        size: i % 5 === 0 ? 2 : 1,
        opacity: 0.25 + (i % 7) * 0.08,
        delay: `${(i % 12) * 0.35}s`,
      })),
    [count],
  );

  return (
    <div className="cs-premium-bg__stars" aria-hidden>
      {stars.map((star) => (
        <span
          key={star.id}
          className="cs-premium-bg__star"
          style={{
            left: star.left,
            top: star.top,
            width: star.size,
            height: star.size,
            opacity: star.opacity,
            animationDelay: star.delay,
          }}
        />
      ))}
    </div>
  );
}

export function PremiumBackground({ subtle = false }: PremiumBackgroundProps) {
  return (
    <div className={`cs-premium-bg${subtle ? ' cs-premium-bg--subtle' : ''}`} aria-hidden>
      <div className="cs-premium-bg__glow" />
      <div className="cs-premium-bg__glow cs-premium-bg__glow--secondary" />
      <Starfield count={subtle ? 24 : 48} />
      <div className="cs-premium-bg__particles" />
    </div>
  );
}
